import styled from 'styled-components';
import { mixFont } from '../../styles/mixins';
import { Headline4, ImageMovieTitleText, ImageMovieYearText } from '../../styles/fonts';

const StyledH2 = styled.h2`
    && {
        ${mixFont(Headline4)};
        text-align: center;
        margin: 0;
        margin-bottom: ${(props) => (props.isMobile ? '45px' : '76px')};
        width: ${(props) => (props.isMobile ? '313px' : '100%')};
        ${({ customstyles }) => customstyles}
    }
`;

const StyledH3 = styled.h3`
    && {
        text-align:center;
        color: black;
        font-size: 12px;
        line-height: 24px;
        letter-spacing: 3px;
        font-family: 'FuturaPT-Book';
        margin: 0;
        margin-top: 30px;
        margin-bottom: 12px;
        ${({ customstyles }) => customstyles}
    }
`;


const StyledSplash = styled.div`
    && {
        flex-direction: column;
        justify-content: flex-start;
        display: flex;
        align-items: center;
    }
`;


const StyledTitle = styled.div`
    && {
        overflow: hidden;
        max-height: 36px;
        ${({ isMobile }) => mixFont(ImageMovieTitleText, isMobile)}
    }
`;

const StyledYear = styled.div`
    && {
        ${({ isMobile }) => mixFont(ImageMovieYearText, isMobile)}
    }
`;

const StyledClosedButton = styled.button`
    && {
        padding: 0;
        margin: 0;
        background: none;
        border: none;
        &:active, &:hover {
            background: transparent;
        }
        &:focus {
            box-shadow: none;
        }
        ${({ customstyles }) => customstyles}
    }
`;

const StyledHelpText = styled.p`
  text-align: center;
  font-size: 16px;
  font-family: 'FuturaPT-Book';
  display: block;
  ${({ customstyles }) => customstyles};
  padding: 0 20px;
`;

export {
  StyledH2,
  StyledH3,
  StyledSplash,
  StyledTitle,
  StyledYear,
  StyledClosedButton,
  StyledHelpText,
};
